import axiosWrapper from './axiosWrapper';
import { getChapter } from '../cache/dataClient';
import cacheSync from '../cache/cacheSync';

const chapterService = {
  // Add a new chapter to a project
  async addChapter(projectId, chapterData) {
    const response = await axiosWrapper({
      method: 'post',
      path: `/projects/${projectId}/chapters`,
      data: chapterData,
    });
    // Update cache after successful creation
    if (!response.error) {
      cacheSync.syncAfterMutation('chapters', response, 'create').catch((err) => {
        console.warn('[chapterService] Error updating cache after create:', err);
      });
    }
    return response;
  },

  // Get a specific chapter by ID (offline-first)
  async getChapterById(chapterId, options = {}) {
    const { useCache = true, backgroundRefresh = false } = options;
    const result = await getChapter(chapterId, { useCache, backgroundRefresh });
    if (result.error && !result.fromCache) {
      return { data: null, error: result.error };
    }

    // Return in format expected by existing code
    return {
      data: { chapter: result.data },
      error: null,
      fromCache: result.fromCache,
    };
  },

  // Update a chapter
  async updateChapter(chapterId, chapterData) {
    const response = await axiosWrapper({
      method: 'put',
      path: `/chapters/${chapterId}`,
      data: chapterData,
    });
    // Update cache after successful update
    if (!response.error) {
      cacheSync.syncAfterMutation('chapters', response, 'update').catch((err) => {
        console.warn('[chapterService] Error updating cache after update:', err);
      });
    }
    return response;
  },

  // Delete a chapter (soft delete)
  async deleteChapter(chapterId) {
    const response = await axiosWrapper({
      method: 'delete',
      path: `/chapters/${chapterId}`,
    });
    // Update cache after successful delete
    if (!response.error) {
      cacheSync.syncAfterMutation('chapters', { id: chapterId }, 'delete').catch((err) => {
        console.warn('[chapterService] Error updating cache after delete:', err);
      });
    }
    return response;
  },
};

export default chapterService;
